/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ddt-detail-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-weight:700}.ddt-detail-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .ddt-detail-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border:2px solid #dee2e6!important}.ddt-detail-table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]{color:#e56c11!important}"];
export { styles as styles };
